var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#BCCCDC",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.363 5.5c0 1.38-1.119 2.5-2.5 2.5-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5c1.381 0 2.5 1.12 2.5 2.5zm.001 10.363c0 1.381-1.12 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5zM5.5 18.363c1.38 0 2.5-1.119 2.5-2.5 0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5c0 1.381 1.12 2.5 2.5 2.5zM8 5.5C8 6.88 6.88 8 5.5 8S3 6.88 3 5.5 4.12 3 5.5 3 8 4.12 8 5.5zM5.5 9c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5s.5-.224.5-.5v-3c0-.276-.224-.5-.5-.5zm8.5.5c0-.276.224-.5.5-.5s.5.224.5.5v3c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3zm-1.697-1.146c-.195-.196-.512-.196-.707 0l-4.242 4.242c-.196.195-.196.512 0 .707.195.196.511.196.707 0l4.242-4.242c.196-.196.196-.512 0-.707z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopLines);
export default __webpack_public_path__ + "static/media/stop-lines.b38b7f2676e0ae5bf3cd3925eeb3d789.svg";
export { ForwardRef as ReactComponent };